import { Menu as MenuPrimitive } from '@base-ui/react/menu';

export type DropdownMenuTriggerProps = MenuPrimitive.Trigger.Props;

const DropdownMenuTrigger = ({ ...props }: DropdownMenuTriggerProps) => {
  return <MenuPrimitive.Trigger data-slot="dropdown-menu-trigger" {...props} />;
};

export default DropdownMenuTrigger;
